// extracted by mini-css-extract-plugin
export var menuItem = "w_tj d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tk d_Z d_bz d_bP";
export var menuMainLink = "w_tl d_f0 d_dB";
export var menuLink = "w_tm d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_tn d_bC d_bP";
export var sublinks = "w_tp";
export var link = "w_m7";
export var Link = "w_ry s_ry s_qM s_q5";